<template>
    <div class="report_preview">
        <a :href="`https://reporting.${rsvDomain}/api/v1/report/${item.uid}`">
            <img v-if="isAchievement" class="report_preview-achievement-medal"
                src="../../assets/images/icons/achievement_medal.png" alt="medal">
            <img :src=getPreview(item.reportType) class="report_preview-image" alt="report">
        </a>
    </div>
</template>

<script>
export default {
    name: 'ReportPreview',
    props: {
        item: Object,
        isAchievement: Boolean,
    },
    computed: {
        rsvDomain() {
            return window.rsvDomain || 'rsv.ru';
        },
    },
    methods: {
        getPreview(type) {
            return require('../../assets/images/account-reporting/' + type + '.png');
        },
    },
};
</script>

<style lang='scss' scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.report_preview {
    position: relative;

    &-shadow-frame {
        -webkit-box-shadow: 0px 0px 10px rgba(131, 134, 163, 0.3);
        -moz-box-shadow: 0px 0px 10px rgba(131, 134, 163, 0.3);
        box-shadow: 0px 0px 10px rgba(131, 134, 163, 0.3);
    }

    &-achievement-medal {
        position: absolute;
        bottom: -12px;
        right: -7px;
    }

    &-image {
        width: 100%;
        height: 100%;
        min-width: 100%;
        min-height: 100%;
    }
}
</style>